import Flex from '@deprecated-ui/common/Flex';
import Link from 'next/link';
import If from 'global/ErrorHandlers/If';
import { convertToSlug } from 'utils/general';
import Image from 'global/Image';
import { BoxHeader, HeaderLink } from './styled';

interface HeaderSectorProps {
  sector?: any;
  subsector?: any;
  showSector: boolean;
  showSubSector: boolean;
  toggleSectorList: () => void;
  onBack: () => void;
}

function HeaderSector({
  sector,
  subsector,
  showSector,
  showSubSector,
  toggleSectorList,
  onBack,
}: HeaderSectorProps) {
  const sectorSlug = convertToSlug(sector?.alias1);

  return (
    <BoxHeader onClick={toggleSectorList}>
      <Flex align="center" style={{ gap: 10 }} className="show-on-mobile">
        <Image
          src="/icon/next.png"
          style={{ height: 12, transform: 'rotate(180deg)' }}
          onClick={onBack}
        />
        <If condition={!sector && !subsector}>
          <Link href="/sector">
            <a>
              <HeaderLink>All Sector</HeaderLink>
            </a>
          </Link>
        </If>
        <If condition={showSector || showSubSector}>
          <HeaderLink active>{subsector?.name || sector?.name}</HeaderLink>
        </If>
      </Flex>
      <Flex align="center" style={{ gap: 8 }} className="hide-on-mobile">
        <Link href="/sector">
          <a>
            <HeaderLink>All Sector</HeaderLink>
          </a>
        </Link>
        <If condition={showSector}>
          <>
            <Image src="/icon/next.png" style={{ height: 12 }} />
            <Link href={`/sector/${sectorSlug}`}>
              <a>
                <HeaderLink active={!showSubSector}>{sector?.name}</HeaderLink>
              </a>
            </Link>
          </>
        </If>
        <If condition={showSubSector}>
          <Image src="/icon/next.png" style={{ height: 12 }} />
          <HeaderLink active>{subsector?.name}</HeaderLink>
        </If>
      </Flex>
      <Image
        src="/icon/next.png"
        onClick={toggleSectorList}
        style={{ height: 16, cursor: 'pointer', transform: 'rotate(90deg)' }}
        className="hide-on-mobile"
      />
    </BoxHeader>
  );
}

export default HeaderSector;
